<template>

    <ur-modal ref="modal" noFoot width="704px;" @closed="resetModal" title="초대하기">
    <div class="modal">
      <div class="modal_dialog">
        <div class="modal_content modal_sm user_invite_pop" >
            <div class="modal_body">
            <p class="txt_desc type2 mt0">AICC 서비스에 새로운 사용자를 초대할 수 있습니다.<br>
              '발송' 버튼을 누르면 입력한 이메일 주소로 AICC 초대 이메일이 발송 됩니다. </p>
            <p class="txt_info">초대는 발송 후 24시간 까지만 유효합니다.</p>
            <div class="tbl_list type2">
              <table>
                <caption>{{$t("MSG_TXT_USR")}} {{$t("MSG_BTN_INVITE")}}</caption>
                <colgroup>
                  <col style="width:167px">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">{{$t("MSG_TXT_EMAIL")}}</th>
                    <td>
                        <aicc-text-field ref="emailtxt" v-model="emailValue"  style="width: 404px;" :placeholder="$t('MSG_TXT_INPUT_EMAIL')"
                           @blur="onBlur"   counter="50" :key="korKey" :rules="emailtxtValidateRule"    :readonly="false" required>
                        </aicc-text-field>
                        <!-- <span class="byte">{{this.emailCnt}}/50</span> -->
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{{$t("MSG_TXT_ACC")}} {{$t("MSG_TXT_LEVEL")}}</th>
                    <td>
                      <ur-dropdown ref="level" style="width: 242px;" v-model="levelValue" :items="dropdownItems" @blur="onBlur" :rules="validateRule" required/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal_footer">
            <ur-button @click="close">{{$t("MSG_BTN_CNCL")}}</ur-button>
            <ur-button @click="inviteUser" :disabled="disableFlag" main>{{$t("MSG_BTN_SEND")}}</ur-button>
          </div>
        </div>
      </div>
    </div>
        <!-- <ur-form-box toggleable column="1">
            <ur-form-item label="이메일" required>
                <ur-text-field ref="email" v-model="emailValue" placeholder="Input text" :rules="validateRule"   @blur="onBlur" :clearable="true" :readonly="false" required>

                </ur-text-field>

            </ur-form-item>
            <ur-form-item label="레벨" required>
                <ur-dropdown ref="level" v-model="levelValue" :items="dropdownItems" @blur="onBlur" :rules="validateRule" required/>
            </ur-form-item>
           
        </ur-form-box>
        <template slot="action">
            <ur-button @click="close">취소</ur-button>
            <ur-button @click="inviteUser" :disabled="disableFlag" main>발송</ur-button> 
        </template>-->
    </ur-modal>
    
</template>
<script>

    const korRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    export default {
        name: 'CMP_AIU_00001',
        props:{
            saasLevelList : {
                type : Array,
                default: () => [],
             }
        },
        data() {
            return {
                levelValue : '',
                disableFlag : true,
                emailFailFlag : false, //이메일이 정상 포멧인지 확인하는 flag
                emailValue: '',
                userInfoAsk: {
                    email: '',
                    levelId:'',
                },
                validateRule: [
                    v=> !!v || '이메일 형식이 올바르지 않습니다.',
                ],
                emailtxtValidateRule: [
                    (v)=> !!v || '이메일 형식이 올바르지 않습니다.',
                    (v)=> !korRegex.test(v) || '이메일 형식이 올바르지 않습니다.',
                    (v)=> utils.isEmailFormat(v) || '이메일 형식이 올바르지 않습니다.',
                    (v)=> aiccUtils.getStringByteSize(v) <= 50 || '최대 50byte까지 입력 가능합니다.'
                ],
                korKey:0,
                emailCnt:0,
                isKor:false,
            }
        },
        computed:{
            dropdownItems(){
                console.log(this.saasLevelList)
                return this.saasLevelList;
            },
            /* emailValidationRule(){
                let result = [];
                result.push(v=> !!v || '이메일 형식이 올바르지 않습니다.');
                if(this.isKor===true){
                    result.push(v=> !!korRegex.test(v) || '이메일 형식이 올바르지 않습니다!!');
                }
                if(this.emailFailFlag === false) {
                    result.push(v=>utils.isEmailFormat(v) || '이메일 형식이 올바르지 않습니다~');
                } 
                console.log(result)
                return result;
            }, */
        },
        updated() {
             if(!this.$refs['level'].isValid()){                    
                 this.disableFlag = true;             
             } else if(this.emailFailFlag&&this.$refs['level'].isValid())  {
                 this.disableFlag = false;
             }         
        },
        /* watch: {
            emailValue: {
                immediate: true,
                handler(newValue, oldValue) {
                     this.emailCnt=aiccUtils.getStringByteSize(newValue);
                    console.log('oldValue', oldValue);
                    console.log('newValue', newValue);  
                    
                    this.isKor = korRegex.test(newValue);
                    
                    console.log("isKor:::::::::::"+this.isKor)
                    console.log("utils.isOnlyKor(newValue):::::::::::"+utils.isOnlyKor(newValue))
                    
                    if(aiccUtils.getStringByteSize(newValue) > 50) {
                        this.emailValue = oldValue;
                        this.korKey++;
                        this.$nextTick(() => {
                            this.$refs['emailtxt'].focus();
                        })
                    }else if (this.isKor===true){
                         this.$refs['emailtxt'].validate(); 
                    } 
                }
            }
        }, */
        methods:{
            /* getByteSize(str){
                let totalByte = 0;
                if(str) {
                for(let ii = 0 ; ii < str.length ; ii++) {
                    const currChar = str.charAt(ii);
                    const uniCurrChar = escape(currChar);
                    if(uniCurrChar.length > 4) {
                            totalByte += 2;
                    } else {
                        totalByte += 1;
                    }
                }
                }
                return totalByte;
            }, */

            open() {
                if(this.saasLevelList.length > 0) {
                    this.levelValue = this.saasLevelList[1].value;
                }
                this.$refs['modal'].open();
            },
            close() {
            	this.resetModal();
                this.$refs['modal'].close();
            },
            resetModal() {
                this.emailValue='';
                this.$nextTick( () => {
                    this.$refs["emailtxt"].clearValidation();
                });
            },
            countLength(maxlength) {
                if (this.emailValue.length > maxlength){
                    this.emailValue = this.emailValue.slice(0, maxlength);
                }
            },
            onBlur() {
                console.log("!!!!!!!!!!!!")
                if(!this.$refs['emailtxt'].isValid()){
                    this.disableFlag = true; 
                    this.emailFailFlag = false; 
                    
                }else{
                    this.disableFlag = false;
                    this.emailFailFlag = true;
                     if(!this.$refs['level'].isValid()){                    
                        this.disableFlag = true;             
                    }
                } 
            },
            inviteUser(){
               // console.log(utils.isEmailFormat(this.emailValue));
                if(!this.$refs['emailtxt'].isValid()||!this.$refs['level'].isValid()){                    
                    return false;
                }
                if(!utils.isEmailFormat(this.emailValue)){
                    return false;
                }
                this.userInfoAsk.levelId = this.levelValue;
                this.userInfoAsk.email = this.emailValue;
                //console.log(this.userInfoAsk);

                http.request('PGE_AIU_00001', 'DTS_AIU_00004', {
                    data: this.userInfoAsk,
                }).then((response) => {
                   if(response.data.reply.code==='0000'){
                       this.$emit('onClose');
                       this.$refs['modal'].close();
                       
                   }else{
                       utils.aiccMessageBox('확인', response.data.reply.korMsg, '확인', null);
                       this.emailValue ="";
                   }
                }); 
                
            }
        }
    }
</script>

<style scoped>
.txt_info{    
    color:rgba(0, 0, 0, 0.5);
}
</style>